import React from 'react'
import Not from 'react-icons/lib/md/error-outline'

const SetupDefault = () => (
  <div className="jumbotron">
    <h1>Setup Semester</h1>
    <p className="lead">These entities are <strong>dependent</strong> on the semester data.</p>
    <hr className="m-y-2" />
    <p><Not /><small> Notice the semester you are in.</small></p>
  </div>
)

export default SetupDefault



// WEBPACK FOOTER //
// ./src/containers/Setup/default.js